//Page Components
import AboutSection1 from "../components/AboutFirstPage";
import AboutSection2 from "../components/AboutSecondPage";
import AboutSection3 from "../components/AboutThirdPage";

const About = () => {
  return (
    <div>
      <AboutSection1 />
      <AboutSection2 />
      <AboutSection3 />
    </div>
  );
};

export default About;
